<template>
  <Transition name="zoom">
    <div class="bg-signableBrandColours-lightGrey z-contextMenu w-full h-full fixed left-0 top-0">
      <div class="flex flex-col h-full">
        <div
          v-if="!!$slots.header"
          class="border-solid border-1 border-l-0 border-t-0 border-r-0"
          data-test="header"
        >
          <div class="flex justify-between gap-base p-md lg:px-xl bg-signableBrandColours-white">
            <h3 class="text-black text-18 font-semibold mb-0">
              <slot name="header" />
            </h3>
            <button
              @click="$emit('close')"
              class="bg-signableBrandColours-white border-none flex items-center cursor-pointer p-0 text-dark3 hover:text-signableBrandColours-black active:text-dark3"
              :aria-label="$t('functional.close')"
              data-ec="full_screen_overlay"
              data-et="close_x_button"
            >
              <XMarkIcon aria-hidden="true" />
            </button>
          </div>
        </div>
        <slot name="default" />
        <div
          v-if="!!$slots.footer"
          class="w-full p-md lg:px-xl bg-signableBrandColours-white relative z-contextMenu border-solid border-1 border-l-0 border-b-0 border-r-0"
          data-test="footer"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';
import { XMarkIcon } from '@/components/library/icons';
import { useEventListener } from '@vueuse/core';

export default defineComponent({
  name: 'OverlayContainer',
  components: { XMarkIcon },

  setup(_, { emit }) {
    useEventListener(document, 'keydown', (e) => {
      if (e.key === 'Escape') {
        emit('close');
      }
    });
  },
});
</script>

<style scoped>
.zoom-enter-active {
  animation: zoom-in .1s;
}
.zoom-leave-active {
  animation: zoom-in .1s reverse;
}

@keyframes zoom-in {
  0% {
    transform: translateY(-50px) scale(0.8);
    opacity: 0;
  }
  50% {
    transform: translateY(-30px) scale(0.9);
    opacity: 0.8;
  }
  100% {
    transform: translateY(0px) scale(1);
    opacity: 1;
  }
}
</style>
